import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// https://gsap.com/docs/v3/GSAP/
// https://greensock.com/docs/v3/Plugins/ScrollTrigger
gsap.registerPlugin(ScrollTrigger, { scroller: ".mainContainer" });

class Animation {
  static splash() {
    const top = document.querySelector(".bgTop");
    this.#setupLines(top);
    // Timeline 逐次処理 https://ics.media/entry/220825/
    gsap
      .timeline()
      // スクロールの設定
      .set(top, {
        scrollTrigger: {
          trigger: top,
          pin: true, // pin の時は start 指定しない
          end: "bottom bottom",
        },
      })
      // 3本線のフェードイン
      .fromTo(
        ".screen__line",
        {
          opacity: 0,
          y: "-100%",
        },
        {
          opacity: 1,
          y: 0,
          ease: "power2.inOut",
          duration: 0.3,
        },
      )
      // ズームしてフェードアウト
      .to(".screen", {
        transform: "scale(5)",
        opacity: 0,
        duration: 2,
        ease: "power2.inOut",
      })
      // ファーストビューのコンテンツ
      // TODO: ここ一括じゃなくて表示順制御したい
      .fromTo(
        ".topBox",
        {
          y: 40,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
        },
      );
  }

  // pin で見せる要素の設定
  static setupSections(sections) {
    sections.forEach((section) => {
      gsap.set(section, {
        scrollTrigger: {
          trigger: section,
          pin: true,
          end: "bottom top",
        },
      });
      this.#setupLines(section);
      this.#seupBoxes(section);
    });
  }

  static #seupBoxes(trigger) {
    const boxes = Array.from(trigger.querySelectorAll(".box"));
    this.#setupEachBox(boxes);
  }

  static #setupEachBox(boxes) {
    const [lhs, rhs] = [boxes.shift(), boxes.shift()];

    if (!lhs) return;

    this.#setupBox(lhs);

    if (!rhs) return;

    this.#setupBox(rhs);

    // 要素が残ってれば再帰
    this.#setupEachBox(boxes);
  }

  static #setupBox(box) {
    gsap.fromTo(
      box,
      {
        opacity: 0,
        y: 84,
      },
      {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          // NOTE: デバッグ時にはマーカーが便利
          // markers: { startColor: "cyan", endColor: "gray", indent: 96 },
          trigger: box,
          start: "top 55%", // これは感覚値
          end: "bottom top",
          // スクロールがアニメーションの進行に影響する係数
          // ここで手触りを調整して親要素(pin)のスクロールマージンを調整する
          // 設定しない場合は逆スクロールには反応しない
          scrub: 1.8,
        },
      },
    );
  }

  static #setupLines(trigger) {
    const el = trigger.querySelector(".line.fadeDown");
    if (!el) return;

    gsap.fromTo(
      el,
      {
        opacity: 0,
        y: -42,
      },
      {
        opacity: 0.8,
        y: 0,
        scrollTrigger: {
          trigger: el,
          start: "top -42", // from: y と同じ値
          end: "bottom top",
          scrub: 2,
        },
      },
    );
  }
}

export const scrubAnimation = () => {
  Animation.splash();
  Animation.setupSections(document.querySelectorAll(".bgFixed"));
};
